import ItemToComponent from '../ItemToComponent/ItemToComponent';
import type { ContentsToReactProps } from './interfaces';

const ContentsToReact = ({ contents, cmsComponents }: ContentsToReactProps) => {
  return (
    <>
      {contents && contents.length > 0
        ? contents.map((item, index) => (
            <ItemToComponent
              key={item.id || index}
              item={item}
              cmsComponents={cmsComponents}
            />
          ))
        : null}
    </>
  );
};

export default ContentsToReact;
